<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.fill_bank')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="main-box">
      <div class="label">
        <span>{{$t("setting.fill_bank_tip")}}</span>
        <span class="bind-tip-num" v-if="bankInfo.count >= 0">{{$t('setting.bound_cards', {count: bankInfo.count, max: bankInfo.max_count})}}</span>
      </div>
      <van-cell-group>
        <van-field v-model="bank" :label="$t('setting.band_name')" readonly :placeholder="$t('setting.band_name_tip')" @click="showSelectBanks()"/>
        <!-- 选中【其它银行卡 QTYH】时显示额外输入框让用户填写具体银行名称 -->
        <van-field v-if="isOtherBank" v-model="other_bank_name" :label="$t('setting.bank_full_name')" :placeholder="$t('setting.bank_full_name_place')" clearable />
        <van-field v-model="bankid" :label="$t('setting.band_account')" type="digit" :placeholder="$t('setting.band_account_tip')" />
        <van-field v-model="username" :label="$t('setting.username')" :placeholder="$t('setting.username_place')" />
        <!-- 首次绑卡（count === 0）：显示两个密码框 → 设置资金密码 -->
        <template v-if="isFirstBind">
          <van-field v-model="opw"  type="password" :label="$t('setting.money_place')" :placeholder="$t('setting.money_place')" />
          <van-field v-model="tpw"   type="password" :label="$t('setting.money_again_place')" :placeholder="$t('setting.money_again_place')" />
          <van-field v-model="mobile" :label="$t('setting.mobile')" type="digit" :placeholder="$t('setting.mobile_place')" />
        </template>
        <!-- 再次绑卡（count > 0）：只显示一个确认密码框，手机号沿用已存数据 -->
        <template v-else>
          <van-field v-model="opw"  type="password" :label="$t('setting.pay_pw_confirm_bind')" :placeholder="$t('setting.pay_pw_confirm_bind')" />
        </template>
      </van-cell-group>
      <p>{{$t("setting.bank_warn")}}</p>
    </div>
    <van-button class="bindCard" type="default" @click="bindCard()">{{$t("setting.bank_ok")}}</van-button>
    <van-popup v-model="showBank" round position="bottom" :style="{ height: '35%' }" >
      <van-picker
          show-toolbar
          :columns="banks"
          @confirm="onConfirm"
          @cancel="onCancel"
		:confirm-button-text="$t('setting.ok')"
		:cancel-button-text="$t('setting.cancel')"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banks: [],
      showBank:false,
      userInfo:{},
      bankid:"",
      username:"",
      mobile:"",
      bank:"",
      bank_code:"",
      other_bank_name: "",   // 选【其它银行卡 QTYH】时，用户自己填的具体银行名称
      opw: '',
      tpw: '',
      bankInfo:{
        count:0,
        max_count:5
      }
    };
  },
  computed:{
    isFirstBind(){
      // 首次绑卡（count===0）要设两次密码；count>0 只要一次确认密码
      return !(this.bankInfo && this.bankInfo.count > 0);
    },
    isOtherBank(){
      // 选中了 bank_list.value=9 / bank_code=QTYH 的「其它银行卡」，要额外输入具体银行名
      return this.bank_code === 'QTYH';
    }
  },
  methods: {
    back(){
      // 从提现页跳过来的绑完返回提现，其它情况正常返回
      const from = this.$route.query && this.$route.query.from;
      if (from === 'withdraw') {
        this.$router.back();
        return;
      }
      return window.history.back();
    },
    bindCard(){

      if(this.bankInfo.count >= this.bankInfo.max_count){
        this.$toast(this.$t('setting.bank_limit_reached', {max: this.bankInfo.max_count}));
        return false;
      }

      if(this.bank === "" || this.bank === null || this.bank === undefined){
        this.$toast.fail(this.$t("setting.band_name_tip"));
        return false;
      }

      // 选中【其它银行卡】时，具体银行名称必填
      if(this.isOtherBank && !this.other_bank_name){
        this.$toast.fail(this.$t('setting.bank_full_name_empty'));
        return false;
      }

      if(this.username===""){
        this.$toast(this.$t("setting.username_place"));
        return false;
      }

      // ========== 密码 + 手机号校验区分 ==========
      if(this.isFirstBind){
        // 首次绑卡：手机号必填
        if(this.mobile===""){
          this.$toast(this.$t("setting.mobile_place"));
          return false;
        }
        // 首次绑卡：两次密码 + 一致性比对
        if(!this.opw.length){
          this.$toast(this.$t("setting.pay_pw_first_empty"));
          return false;
        }
        if(!this.tpw.length){
          this.$toast(this.$t("setting.pay_pw_again_empty"));
          return false;
        }
        if(this.opw !== this.tpw){
          this.$toast(this.$t("setting.pwd_error"));
          return false;
        }
      } else {
        // 再次绑卡：只要确认一次密码，手机号沿用数据库已存的 mobile
        if(!this.opw.length){
          this.$toast(this.$t("setting.pay_pw_confirm_bind"));
          return false;
        }
        // 如果前端 userInfo 有手机号，顺手带过去（后端也会兜底拿 member.mobile）
        if(!this.mobile && this.userInfo && this.userInfo.mobile){
          this.mobile = this.userInfo.mobile;
        }
      }

      // 提交时：【其它银行卡】bank 字段用用户填的具体名称，bank_code 保持 QTYH
      const submitBank = this.isOtherBank ? this.other_bank_name : this.bank;

      this.$http({
        method: 'post',
        data:{
          bankid:this.bankid,
          bank:submitBank,
          bank_code: this.bank_code,
          username:this.username,
          mobile:this.mobile,
          opw:this.opw,
          tpw:this.isFirstBind ? this.tpw : ''
        },
        url: 'user_set_bank'
      }).then(res=>{
        if(res.code === 200){
          this.$toast(res.msg);
          // 绑卡成功：刷新列表 & 清空表单，便于继续添加下一张
          this.bankid = "";
          this.username = "";
          // 再次绑卡后不清空 mobile 缓存（避免下次提交空）
          if(this.isFirstBind){ this.mobile = ""; }
          this.bank = "";
          this.bank_code = "";
          this.other_bank_name = "";
          this.opw = "";
          this.tpw = "";
          this.getUserBankInfo();
          this.getUserInfo();
          // 从提现页进来的，返回；如果不满 5 张提示用户还能绑
          const from = this.$route.query && this.$route.query.from;
          if (from === 'withdraw') {
            setTimeout(()=>{ this.$router.back(); }, 600);
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    showSelectBanks(){
      this.showBank = true;
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getBankList(){
      this.$http({
        method: 'get',
        url: 'sys_get_banks'
      }).then(res=>{
        if(res.code === 200){
          this.banks = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    onConfirm(value) {
      this.bank = value.text
      this.bank_code = value.value
      this.showBank = false;
    },
    onCancel() {
      this.showBank = false;
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          const d = res.data || {};
          this.bankInfo.count = d.count || 0;
          this.bankInfo.max_count = d.max_count || 5;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getBankList();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 32px;
  line-height: 80px;
}
.van-hairline--bottom::after {
  border-bottom-width: 3px;
}
.bankbox{
  padding: 15px;
  color: #000;
  background-color: #fff;
}
.bankbox .title{
  padding: 8px 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
}
.main-box{
  background: #fff;

}
.main-box .label{
  padding: 20px;
  font-size: 35px;
  color: #797878;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}
.bind-tip-num{
  font-size: 26px;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(152,143,186,0.08);
  color: #7b5fb4;
}
::v-deep .van-picker__toolbar {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ebedf0;
}
::v-deep .van-picker__cancel {
  padding: 0 28px;
  font-size: 30px;
  color: #969799;
  font-weight: normal;
}
::v-deep .van-picker__confirm {
  padding: 0 28px;
  font-size: 30px;
  color: #7b5fb4;
  font-weight: 600;
}
::v-deep .van-picker-column {
  font-size: 34px;
  line-height: 48px;
}
.main-box p{
  padding: 0 20px;
  font-size: 30px;
  color: #ee0a24;
}
.bindCard {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(
      90deg,#988fba,#f487e0);
}
</style>
